import CartProduct from "./CartProduct";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

function CartProductList(props) {
	return (
		<Row>
			{props.product.map((eachproduct, index) => {
				return (
					<Col xs={12} md={12} lg={12} xl={12} xxl={12} key={index}>
						{<CartProduct {...eachproduct} />}
					</Col>
				);
			})}
		</Row>
	);
}
export default CartProductList;
